// Cookie 读写的小工具 / Small helpers for reading and deleting document cookies.
// 仅处理非 HttpOnly cookie（例如 CSRF token），避免依赖运行时外的库。
// Only covers non-HttpOnly cookies (e.g. CSRF token) to stay dependency-free.

export function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
}

// 写入前端可见 cookie / Write a frontend-visible cookie.
export function writeCookie(name: string, value: string, path: string = "/"): void {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=${path}; SameSite=Lax`;
}

export function deleteCookie(name: string, path: string = "/"): void {
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
